<template>
    <svg viewBox="-12 -12 24 24" width="24" height="24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">
        <polyline v-for="(path,index) in symbol.paths || []" :key="'path'+index" :points="path.map(point=>point.join(',')).join(' ')" />
        <g v-for="(body,index) in symbol.candles || []" :key="'body'+index">
            <line :x1="body.x" :x2="body.x" :y1="body.high" :y2="body.top" /><line :x1="body.x" :x2="body.x" :y1="body.bottom" :y2="body.low" />
            <line v-if="body.top===body.bottom" :x1="body.x-4" :x2="body.x+4" :y1="body.top" :y2="body.top" />
            <rect v-else :x="body.x-2" :y="body.top" width="4" :height="body.bottom-body.top" :fill="body.filled?'currentColor':'none'" />
        </g>
    </svg>
</template>
<script>
export default {name:'PatternSymbolIcon',props:{symbol:{type:Object,required:true}}}
</script>
